module.exports = __webpack_public_path__ + "static/media/pound.22100e61.svg";